module.exports = __webpack_public_path__ + "static/media/em-119.5be47be3.png";